// @flow

// @TODO: Replace outcome of this function with $Rest when we upgraded to Flow 0.56+
function removePropertyFromObject<O: { [string]: any }, K: string>(obj: O, key: K): Object {
  const {
    [key]: _,
    ...otherProps
  } = obj;

  return otherProps;
}

export default removePropertyFromObject;
